import { render, staticRenderFns } from "./TestbankQuestionChoice.vue?vue&type=template&id=2197f8f1&scoped=true&"
import script from "./TestbankQuestionChoice.vue?vue&type=script&lang=js&"
export * from "./TestbankQuestionChoice.vue?vue&type=script&lang=js&"
import style0 from "./TestbankQuestionChoice.vue?vue&type=style&index=0&id=2197f8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2197f8f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2197f8f1')) {
      api.createRecord('2197f8f1', component.options)
    } else {
      api.reload('2197f8f1', component.options)
    }
    module.hot.accept("./TestbankQuestionChoice.vue?vue&type=template&id=2197f8f1&scoped=true&", function () {
      api.rerender('2197f8f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Question/TestbankQuestionChoice.vue"
export default component.exports